import React from 'react';
import { Inscription } from '@common-fe/common-fe';

interface Props {
  testId?: string;
  onClick: () => void;
}

const OpenChangeVerificationMethodModalButton: React.FC<Props> = ({ testId, onClick }) => {
  return (
    <Inscription
      data-testId={`${testId}_change-verification-method-button`}
      color="textAccent"
      size="small"
      weight={500}
      onClick={onClick}
      cursor="pointer"
    >
      Change verification method
    </Inscription>
  );
};

export default OpenChangeVerificationMethodModalButton;
